import { render, staticRenderFns } from "./FieldSchemapropertieseditor.vue?vue&type=template&id=6a956f30&scoped=true&"
import script from "./FieldSchemapropertieseditor.vue?vue&type=script&lang=js&"
export * from "./FieldSchemapropertieseditor.vue?vue&type=script&lang=js&"
import style0 from "./FieldSchemapropertieseditor.vue?vue&type=style&index=0&id=6a956f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a956f30",
  null
  
)

export default component.exports